import Api from '../shared/Api';

class ContentApi {
    static getContent(): any {
        return new Api().get('/content');
    }
}

export default ContentApi;
